var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceBayt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9991C22 19.7612 19.7612 22 17.0001 22H6.99995C4.23793 22 2 19.7612 2 16.9991V7.00008C2 4.238 4.23793 2 6.99995 2H17.0001C19.7612 2 22 4.238 22 7.00008L22 16.9991Z",
    fill: "#2784FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2627 10.0312V13.0938M13.2627 13.0938V13.5001C13.2627 14.6046 14.1581 15.5001 15.2627 15.5001H17.7972C18.4617 15.5001 19.0004 14.9614 19.0004 14.2969C19.0004 13.6325 18.4617 13.0938 17.7972 13.0938H13.2627Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4426 9.15626L5 10.9063V10.25L8.4426 8.5L11.8852 10.25V10.9063L8.4426 9.15626Z",
    fill: "#FBC030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceBayt);
export default __webpack_public_path__ + "static/media/source-bayt.47a9388c4b46fe6bd11d8d334ac76baf.svg";
export { ForwardRef as ReactComponent };